// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3mcNq","actions":"GroupTable_actions__2drsY","deleteModalFooter":"GroupTable_deleteModalFooter__2DqKv"};